import { type Themeable, useThemeable } from '../../themeable'
import { Container } from '../Container'
import { Overlay } from '../Overlay'
import { Circle } from './Circle'
import { Svg } from './Svg'

type Options = {
	color: string
	width?: number
	size?: number
}

type Props = {
	showOverlay?: boolean
}

/**
 * Create an animated spinner in material UI-style. Setup of SVG elements and
 * animations taken from MUI.
 */
export const createSpinnerMaterial =
	(options: Themeable<Options>) =>
	({ showOverlay = false }: Props) => {
		const { color, width = 1, size = 32 } = useThemeable(options)

		return (
			<>
				<Container size={size}>
					<Svg>
						<Circle color={useThemeable(color)} width={width} />
					</Svg>
				</Container>
				{showOverlay && <Overlay />}
			</>
		)
	}
